import { classnames } from 'helpers/utils/classnames';
import { TableHTMLAttributes } from 'react';

const TableContainer = ({ className, ...props }: TableHTMLAttributes<HTMLTableElement>) => {
  const tableClassName = classnames(
    'relative block w-full overflow-x-auto rounded-md border-t border-neutral-400 md:table',
    className,
  );
  return <table className={tableClassName} {...props} />;
};

export default TableContainer;
